<template>
  <span
    :class="{
      'osk-concierge-more-details': true,
    }"
    @click.stop.prevent="handleMore"
  >
    {{ $t('components.concierge.details.more') }}
  </span>

  <UikitDialog
    v-model="isDialog"
    full-height
    position="right"
    content-class="osk-concierge-more-details-dialog"
  >
    <div class="osk-concierge-more-details-dialog__wrapper">
      <div class="osk-concierge-more-details-dialog__content">
        <div class="osk-concierge-more-details-dialog__first-block">
          <div class="osk-concierge-more-details-dialog__first-block-title">
            Concierge
          </div>

          <div class="osk-concierge-more-details-dialog__first-block-text">
            {{ $t('components.concierge.details.description') }}
          </div>
        </div>

        <div class="osk-concierge-more-details-dialog__block">
          <div class="osk-concierge-more-details-dialog__block-title">
            {{ $t('components.concierge.details.aboutTitle') }}
          </div>

          <div class="osk-concierge-more-details-dialog__block-text">
            {{ $t('components.concierge.details.aboutText') }}
          </div>
        </div>

        <div class="osk-concierge-more-details-dialog__block">
          <div class="osk-concierge-more-details-dialog__block-title">
            {{ $t('components.concierge.details.whyTitle') }}
          </div>

          <div class="osk-concierge-more-details-dialog__block-text">
            <strong>{{ $t('components.concierge.details.safe') }}</strong> {{ $t('components.concierge.details.safeText') }}
          </div>

          <div class="osk-concierge-more-details-dialog__block-text">
            <strong>{{ $t('components.concierge.details.new') }}</strong> {{ $t('components.concierge.details.newText') }}
          </div>

          <div class="osk-concierge-more-details-dialog__block-text">
            <strong>{{ $t('components.concierge.details.delivery') }}</strong> {{ $t('components.concierge.details.deliveryText') }}
          </div>
        </div>

        <div class="osk-concierge-more-details-dialog__block">
          <div class="osk-concierge-more-details-dialog__block-title">
            {{ $t('components.concierge.details.how') }}
          </div>

          <div class="osk-concierge-more-details-dialog__block-text">
            {{ $t('components.concierge.details.howText1') }}
          </div>

          <div class="osk-concierge-more-details-dialog__block-text">
            {{ $t('components.concierge.details.howText2') }}
          </div>
          <div class="osk-concierge-more-details-dialog__block-image">
            <img
              v-if="!isInternational"
              src="~/assets/img/concierge/iphones.webp"
              alt="iphones"
            >
            <img
              v-else
              style="width: 100%"
              alt="iphones"
              src="~/assets/img/concierge/iphones-int.webp"
            >
          </div>

          <div class="osk-concierge-more-details-dialog__block-text">
            {{ $t('components.concierge.details.questions') }}
          </div>
        </div>
      </div>

      <div class="osk-concierge-more-details-dialog__footer">
        <UikitButton
          full-width
          @click="isDialog = false"
        >
          {{ $t('components.concierge.details.goToDialog') }}
        </UikitButton>

        <UikitButton
          v-if="!isHomeBanner"
          color="secondary"
          full-width
          @click="goToConcierge"
        >
          {{ $t('components.concierge.details.goToCatalog') }}
        </UikitButton>
      </div>
    </div>
  </UikitDialog>
</template>

<script lang="ts" setup>
const props = defineProps<{
  disabled?: boolean
  title?: string
}>();

const emits = defineEmits<{
  (e: 'open'): void,
}>();

const isDialog = ref(false);

const { isInternational } = useInternational();
const { goToConcierge } = useConcierge();
const route = useRoute();

const isHomeBanner = computed(() => route.fullPath.includes('homeBanner'));

function handleMore() {
  if (props.disabled) return;

  isDialog.value = true;

  emits('open');
}
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-concierge-more-details {
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  @include media-query(lg-and-up) {
    color: $grey;
  }
}

.osk-concierge-more-details-dialog {
  padding: 0 !important;

  @include media-query(lg-and-up) {
    width: 504px !important;
  }

  .osk-dialog__close {
    background: rgba(0,0,0,.2);
    border-radius: 100px;
    padding: 4px;
    right: 16px;
    top: 24px;
    z-index: 2;

    .osk-icon {
      width: 20px;
      height: 20px;
      color: #fff;
    }

    @include media-query(lg-and-up) {
      right: 50px;
      top: 44px;
    }
  }

  &__first-block {
    position: relative;
    background-image: url('~/assets/img/concierge/concierge-more.webp');
    background-size: cover;
    color: #fff;
    text-align: center;
    padding-top: 231px;

    @include media-query(lg-and-up) {
      padding-top: 325px;
    }

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: linear-gradient(360deg, #111 0%, rgba(17, 17, 17, 0.77) 0.07%, rgba(17, 17, 17, 0.67) 40.00%,
      rgba(17, 17, 17, 0.56) 46.67%, rgba(17, 17, 17, 0.44) 53.33%, rgba(17, 17, 17, 0.33) 60.00%,
      rgba(17, 17, 17, 0.23) 66.67%, rgba(17, 17, 17, 0.15) 73.33%, rgba(17, 17, 17, 0.08) 80.00%,
      rgba(17, 17, 17, 0.04) 86.67%, rgba(17, 17, 17, 0.01) 93.33%, rgba(17, 17, 17, 0.00) 100%);
    }
  }

  &__first-block-title {
    font-family: 'Playfair Display', serif;
    font-size: 52px;
    font-style: italic;
    font-weight: 400;
    line-height: 95%;
    margin-bottom: 24px;
    z-index: 1;
    position: relative;

    @include media-query(lg-and-up) {
      margin-bottom: 32px;
    }
  }

  &__first-block-text {
    z-index: 1;
    position: relative;
    padding: 0 16px 100px;
    line-height: 20px;

    @include media-query(lg-and-up) {
      padding: 0 52px 95px;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 100%;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__title {
    font-weight: 700;
    font-size: 22px;
    line-height: 27px;
    margin-bottom: 34px;

    @include media-query(lg-and-up) {
      @include font-style($font-size-heading, $line-height-heading, $font-weight-bold);
      margin-bottom: 32px;
    }
  }

  &__footer {
    padding: $indent-mmedium $indent-medium $indent-medium;

    @include media-query(lg-and-up) {
      padding: $indent-large 52px $indent-large;
    }

    .osk-button:first-child:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  &__block {
    padding: 0 16px;
    margin-bottom: 32px;

    @include media-query(lg-and-up) {
      padding: 0 52px;
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__block-title {
    padding: 10px 0;
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 700;
    line-height: normal;

    @include media-query(lg-and-up) {
      padding-top: 16px;
    }
  }

  &__block-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;

    @include media-query(lg-and-up) {
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
    }

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }

  &__block-image {
    padding: 8px 16px 32px;
  }
}
</style>
